import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import "./Style/styles.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";
import { injectStore } from "./util/util";
import { ThemeProvider } from '../src/themeContext';
import '../src/Style/global.scss'; 

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

injectStore(store);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
      <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
